import React from 'react';

import './styles.scss';

export const HorizontalDivider = ({ className = '' }) => (
  <div className={`${className} horizontal-divider`} />
);
